export default __webpack_public_path__ + "static/media/C0002.b2aa7941.png";